<template>
  <!--Edit Mode START-->
  <div v-if="isModalShown">
      <div class="modal-mask" role="dialog">
        <div class="overlay-mask">
          <div class="modal-dialog modal-lg">
              <div class="modal-content modal-edit-bg">
                  <div class="modal-body">
                      <div v-if="isFormLoading" class="row">
                        <page-loader></page-loader>
                      </div>
                      <div v-else>
                        <div class="close_btn" v-on:click="CloseModal()"></div><br>
                        <div class="row">
                          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="max-height:700px; overflow-y:auto; overflow-x:hidden;">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 edit_account_modal">
                              <div class="my-account-title">Professional Information</div>
                              <div class="account_section_box">
                                <div class="row">
                                </div>
                                <div class="row">
                                  <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                    <label class="account_label">NPI Number:</label>
                                  </div>
                                  <div class="col-lg-8 col-md-8 col-sm-8 col-xs-8">
                                    <div class="form-group" v-show="FormInputs.AccountNpiNumber">
                                      <label>zNPI Number<span v-if="!AccountEdit.useLicenseNumber">*</span> <span v-bind:data-balloon="npiTooltip" data-balloon-pos="down" data-balloon-length="large"><i class="fa fa-question-circle-o"></i></span></label>
                                      <input type="text" maxlength="10" v-model="AccountEdit.npiNumber" class="form-control input_field"
                                      v-on:keypress="G_NumberCheck(this.event)" v-on:keyup="ValidateNpiNumber()">
                                      <p class="error-message" v-if="AccountValidationResult.AccountNpiNumber">{{AccountValidationResult.AccountNpiNumber}}</p>
                                      <div class="form-check" v-show="FormInputs.AccountHasNpiNumber">
                                        <input value="" v-model="AccountEdit.useLicenseNumber" type="checkbox" class="form-check-input">
                                        <label>I don't have an NPI number</label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="row" v-if="AccountEdit.useLicenseNumber == true" >
                                  <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                    <label class="account_label">License Number/State:</label>
                                  </div>
                                  <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                                    <div class="row">
                                      <div class="col-lg-6 col-md-12 col-sm-6 col-xs-12">
                                        <div class="form-group">
                                          <label>License Number*</label>
                                          <input  maxlength="18" v-bind:class="{ error_field: AccountValidationResult.AccountLicenseNumber }" v-model="AccountEdit.licenseNumber" type="text" class="form-control input_field">
                                          <p class="error-message" v-if="AccountValidationResult.AccountLicenseNumber">{{AccountValidationResult.AccountLicenseNumber}}</p>
                                        </div>
                                      </div>
                                      <div class="col-lg-6 col-md-12 col-sm-6 col-xs-12">
                                        <div class="form-group" >
                                          <label>State*</label>
                                          <select v-bind:class="{ error_field: AccountValidationResult.AccountState }" v-model="AccountEdit.state" class="form-control select_field">
                                              <option v-for="(value, key) in State" v-bind:value="value">{{value}}</option>
                                          </select>
                                          <p class="error-message" v-if="AccountValidationResult.AccountState">{{AccountValidationResult.AccountState}}</p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                    <label class="account_label">Year Licensed:</label>
                                  </div>
                                  <div class="col-lg-8 col-md-8 col-sm-8 col-xs-8">
                                    <div class="form-group">
                                        <label>Year Licensed</label>
                                        <div class="row">
                                            <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                                <input v-model="AccountEdit.primaryContact.yearsInPractice" v-on:keypress="G_NumberCheck(this.event)"
                                                v-on:keyup="G_NumberOfYearsCheck(AccountEdit.primaryContact, 'yearsInPractice');"
                                                min="1" type="number" class="form-control input_field"
                                                v-on:blur="CheckYearLicense(AccountEdit.primaryContact.yearsInPractice)">
                                                <!-- REAL TIME VALIDATION -->
                                                <p v-if="errorMessage.year" class="error-message">{{errorMessage.year}}</p>
                                            </div>
                                        </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                      <label class="account_label">Professional Associations:</label>
                                  </div>
                                  <div class="col-lg-8 col-md-8 col-sm-8 col-xs-8">
                                    <div class="form-group">
                                      <div v-for="(value, key) in CheckboxIndividual" class="form-check" v-if="FormInputs.IndividualOrganization">
                                        <span class="form-check-label account_p" v-if="AccountEdit.organizations">
                                            <input :value="key" v-model="AccountEdit.organizations.list" class="form-check-input" type="checkbox">
                                            {{key}}
                                        </span>
                                      </div>
                                      <div class="form-group" v-if="AccountEdit.organizations.list.indexOf('Other') >= 0">
                                          <span class="account_p">Please enter any other professional organizations you are associated with separated by semicolon(;).</span>
                                          <input type="text" v-model="AccountEdit.organizations.others" class="form-control input_field">
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 center">
                              <button class="btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-mx-10" v-on:click="SaveInfo()">Save</button>
                              <button class="btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130 g-mx-10" v-on:click="CloseModal()">Cancel</button>
                          </div>
                        </div>
                      </div>
                  </div>
              </div>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
import PageLoader from "@/components/shared/PageLoader";
export default {
  props: [
    "AccountEdit",
    "FormInputs",
    "Suffix",
    "State",
    'CheckboxIndividual',
    'AccountValidationResult',
    'isFormLoading',

  ],
  components: {PageLoader},
  data() {
    return {
        isModalShown: true,
        errorMessage: {
          year: null
        }
    }
  },
  methods: {
    CloseModal() {
      this.isModalShown = false;
      this.$emit("modalClick");
      document.body.classList.remove("body-overflow");
    },
    SaveInfo() {
      this.$emit("saveProfessional");
    },
    ValidateNpiNumber() {
        this.$emit("npiIsDirty");
    },
    CheckYearLicense(yearPractice) {
        var year = yearPractice;
        var result = this.G_CheckYearLicense(year);
        if(result)
            this.errorMessage.year = result;
        else
            this.errorMessage.year = "";
    }
  }
}
</script>



// WEBPACK FOOTER //
// EditProfessionalInfo.vue?bc49eaee